import { FC } from 'react';

export const CloudSvg: FC = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2114_44934)">
        <path
          opacity="0.3"
          d="M38.42 24.08L35.36 23.86L34.76 20.86C33.76 15.72 29.24 12 24 12C19.88 12 16.16 14.28 14.24 17.92L13.24 19.82L11.1 20.04C7.06 20.48 4 23.9 4 28C4 32.42 7.58 36 12 36H38C41.3 36 44 33.3 44 30C44 26.9 41.56 24.28 38.42 24.08ZM26.9 26V32H21.08V26H16L24 18L32 26H26.9Z"
          fill="#4F545E"
        />
        <path
          d="M38.7 20.08C37.34 13.18 31.28 8 24 8C18.22 8 13.2 11.28 10.7 16.08C4.68 16.72 0 21.82 0 28C0 34.62 5.38 40 12 40H38C43.52 40 48 35.52 48 30C48 24.72 43.9 20.44 38.7 20.08ZM38 36H12C7.58 36 4 32.42 4 28C4 23.9 7.06 20.48 11.12 20.06L13.26 19.84L14.26 17.94C16.16 14.28 19.88 12 24 12C29.24 12 33.76 15.72 34.78 20.86L35.38 23.86L38.44 24.08C41.56 24.28 44 26.9 44 30C44 33.3 41.3 36 38 36ZM16 26H21.1V32H26.9V26H32L24 18L16 26Z"
          fill="#4F545E"
        />
      </g>
      <defs>
        <clipPath id="clip0_2114_44934">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
